import React from "react";

export default function ExpertAdvice() {
  return (
    <section id="expert-advice" className="expert-advice section section-dark">
      <div className="container">
        {/* Заголовок и подзаголовок */}
        <div className="section-header">
          <div className="section-badge">Совет от разработчика</div>
          <h2>Как сэкономить на старте?</h2>
          <p className="section-subtitle">
            Выбор технологии напрямую зависит от вашей бизнес-цели.
          </p>
          <p className="section-subtitle">
            Вот честный разбор двух самых частых сценариев.
          </p>
        </div>

        {/* Основное содержание */}
        <div className="grid">
          
          {/* Карточка 1: Проверка гипотезы (CRA) */}
          <div className="text-content" style={{ marginBottom: '3rem' }}>
            <h3>Мне просто нужно проверить идею</h3>
            <p>
              Цель - быстро показать продукт первым пользователям и понять, нужен ли он рынку, не рискуя большим бюджетом.
            </p>
            <ul className="benefits-list">
              <li><span className="checkmark ">✓</span> Разработка MVP на React с базовой SEO-настройкой.</li>
              <li><span className="checkmark ">✓</span> Это быстрее и дешевле в разработке и хостинге.</li>
              <li><span className="checkmark ">✓</span> Вы получаете работающий продукт для проверки идеи.</li>
            </ul>
          </div>

          {/* Карточка 2: Масштабирование (Next.js) */}
          <div className="text-content">
            <h3>Я готов к росту и хочу клиентов из поиска</h3>
            <p>
              Цель - привлекать тысячи клиентов из поиска, занять высокие позиции в Яндексе и Google, расти в долгосрочной перспективе и инвестировать в маркетинг.
            </p>
            <ul className="benefits-list">
              <li><span className="checkmark ">✓</span> Разработка на Next.js с продвинутой SEO-оптимизацией.</li>
              <li><span className="checkmark ">✓</span> Гарантирует отличную индексацию и высокие позиции в поиске.</li>
              <li><span className="checkmark ">✓</span> Это инвестиция в будущее вашего проекта.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}